import React from 'react';
import { Link } from 'react-router-dom';
import './WRASCertificate.css';

const WRASCertificate = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <div className="page-breadcrumb">Quality Certification</div>
            <h1 className="page-title">WRAS Certificate</h1>
            <div className="page-text-content">
              <p>
                Hello Esteemed Visitors,
              </p>
              <p>
                As NQC (Nova Quality Certification Agency), we continue our commitment to providing 
                you with the highest quality of service as a professional service provider specialized 
                in certification and compliance. In this article, we aim to provide detailed 
                information about WRAS Certification, one of the services we offer.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">What is WRAS?</h2>
            <div className="page-text-content">
              <p>
                WRAS stands for Water Regulations Advisory Scheme, an acronym formed from the 
                initials of the words. WRAS Certification signifies an approval system that 
                demonstrates compliance with regulations related to water supply and usage in England 
                and Wales. It confirms the suitability of plumbing products and materials for use in 
                domestic water systems.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Why Should You Obtain WRAS Certification?</h2>
            <div className="reasons-list">
              <div className="reason-item">
                <h3 className="reason-title">1. Water Safety</h3>
                <p className="reason-description">
                  WRAS Certification indicates that plumbing products are safe and hygienic, ensuring 
                  the cleanliness and safety of water and protecting the health of users.
                </p>
              </div>
              <div className="reason-item">
                <h3 className="reason-title">2. Legal Compliance</h3>
                <p className="reason-description">
                  In England and Wales, plumbing products must have WRAS approval. WRAS Certification 
                  confirms compliance with legal requirements, protecting your business from legal issues.
                </p>
              </div>
              <div className="reason-item">
                <h3 className="reason-title">3. Market Access</h3>
                <p className="reason-description">
                  WRAS Certification facilitates access to the markets in England and Wales for your 
                  plumbing products. Products with this certification are preferred for construction 
                  projects.
                </p>
              </div>
              <div className="reason-item">
                <h3 className="reason-title">4. Customer Trust</h3>
                <p className="reason-description">
                  WRAS Certification assures your customers that your products are of high quality 
                  and safe, increasing customer trust and maintaining your brand reputation.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">How to Obtain WRAS Certification?</h2>
            <div className="page-text-content">
              <p>
                To obtain WRAS Certification, your products and plumbing systems must comply with WRAS 
                standards. NQC (Nova Quality Certification Agency) guides you through this process. 
                Our experienced professionals provide tailored solutions tailored to your business 
                needs and help you successfully complete the certification process.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Why Choose NQC (Nova Quality Certification Agency)?</h2>
            <div className="page-text-content">
              <p>
                At NQC (Nova Quality Certification Agency), we offer high-quality certification 
                services, including WRAS Certification, with expertise in various fields. We provide 
                customized solutions tailored to your business needs and manage the certification 
                process efficiently for you.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Final Words</h2>
            <div className="page-text-content">
              <p>
                WRAS Certification is an important approval that demonstrates your plumbing products 
                are safe and hygienic. As NQC (Nova Quality Certification Agency), we are proud to 
                assist your business in obtaining this valuable certification. By collaborating with 
                us to ensure water safety and quality, you can help your business grow and gain a 
                competitive advantage.
              </p>
              <p>
                If you have any questions or need more information about our certification services, 
                our expert team will be happy to assist you.
              </p>
              <p>
                Best wishes!
              </p>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default WRASCertificate;

